import React from 'react';

export default function InputError({
  className,
  hasError,
  children,
}) {
  return (
  <div className={`input-error c-red lh1.5 ${hasError ? 'db' : 'dn'} ${ className || '' }`}>
  { children }
  </div>
  )
}